import React from 'react';
import { useIntl } from 'react-intl';

import HelpIcon from '@mui/icons-material/Help';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { Alert, Box, Grid, Tooltip, Typography } from '@mui/material';
import { FONT_FAMILY } from '@provider-portal/common/styles/themeMui';

import { PromotionCreationAlert } from '../PromotionCreationAlert/PromotionCreationAlert';

interface Props {
  title: string;
  subtitle: string;
  helpText?: string;
  isMetricBanned?: boolean;
  foodBannedUntil?: number;
}

const MetricBanAlert = () => {
  const intl = useIntl();
  return (
    <Alert
      icon={
        <WarningRoundedIcon
          fontSize="inherit"
          sx={{
            color: '#FFC529',
          }}
        />
      }
      severity="success"
      sx={{
        color: '#2F313F',
        fontFamily: FONT_FAMILY,
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '24px',
        background: '#FFF5CC',
      }}
    >
      {intl.formatMessage({
        id: 'components.promotionEligibility.promotionSection.subTitle',
      })}
      <Box>
        {intl.formatMessage({
          id: 'components.promotionEligibility.promotionSection.updateDuration',
        })}
      </Box>
    </Alert>
  );
};

export const SetupNewPromotionSection: React.FC<Props> = ({
  title,
  subtitle,
  helpText,
  isMetricBanned,
  children,
  foodBannedUntil,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box mb={1}>
        <Grid container direction="row" alignItems="center" gap="17px">
          <Grid item>
            <Typography variant="h6" color="textPrimary">
              {title}
            </Typography>
          </Grid>
          {helpText && (
            <Grid item>
              <Tooltip
                title={<Typography variant="inherit">{helpText}</Typography>}
                arrow
                placement="bottom-end"
              >
                <HelpIcon />
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box mb={3}>
        {isMetricBanned ? (
          <MetricBanAlert />
        ) : (
          <>
            <Typography variant="bodyM" color="textSecondary">
              {subtitle}
            </Typography>
            {foodBannedUntil && (
              <Box mt={3}>
                <PromotionCreationAlert bannedUntil={foodBannedUntil} />
              </Box>
            )}
          </>
        )}
      </Box>
      {children}
    </Box>
  );
};
